"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MachineDetailPage = void 0;
var MachineDetail_1 = require("./MachineDetail");
Object.defineProperty(exports, "MachineDetailPage", { enumerable: true, get: function () { return MachineDetail_1.MachineDetail; } });
